import { twMerge } from "tailwind-merge";
import {
  CatalogLink,
  CatalogAutoplayButton,
  CatalogPagingButton,
} from "catalog/CatalogNavigations";
import { useParams } from "react-router-dom";
import { Image } from "components/elements";
import { useState } from "react";
import { useCatalog } from "catalog/Catalog.context";

export default function GlobalNavigation() {
  const { pageSlug1, pageSlug2, lang } = useParams();
  const { isResponsive } = useCatalog();
  const [isLnbActive, setIsLnbActive] = useState(false);

  return (
    <div className="pointer-events-none absolute left-0 top-0 z-[9999] h-full w-full">
      <header
        className={twMerge(
          "header relative flex h-[80px] w-full items-center justify-between gap-8 pl-10 *:pointer-events-auto",
          pageSlug1 === "cover" || pageSlug1 === "intro"
            ? "-translate-y-[100px]"
            : "translate-y-[0px]",
          pageSlug1 === "cover" || pageSlug1 === "catalog-index" || pageSlug1 === "last"
            ? "bg-transparent"
            : "bg-black",
        )}
      >
        <CatalogLink
          to={`/intro`}
          className={twMerge(!isResponsive && pageSlug1 === "last" && "hidden")}
        >
          <Image src="/common/logo-white.png"></Image>
        </CatalogLink>

        <div className={twMerge("flex w-full items-center gap-12", "mo:justify-end")}>
          <nav
            className={twMerge(
              "gnb-bar",
              pageSlug1 === "catalog-index" || pageSlug1 === "last"
                ? "-translate-y-[100px]"
                : "translate-y-[0]",
            )}
          >
            <div
              className={twMerge("gnb", pageSlug1 === "technology" && "active")}
              onMouseEnter={() => setIsLnbActive("technology")}
              onMouseLeave={() => setIsLnbActive(false)}
            >
              <CatalogLink
                className={twMerge("btn", pageSlug1 === "technology" && "active")}
                to="technology/lorawan"
              >
                Technology
              </CatalogLink>
            </div>
            <div
              className={twMerge("gnb", pageSlug1 === "solution" && "active")}
              onMouseEnter={() => setIsLnbActive("solution")}
              onMouseLeave={() => setIsLnbActive(false)}
            >
              <CatalogLink
                className={twMerge("btn", pageSlug1 === "solution" && "active")}
                to="solution/total-solution/cover"
              >
                Solution
              </CatalogLink>
            </div>
            <div
              className="gnb"
              onMouseEnter={() => setIsLnbActive("company")}
              onMouseLeave={() => setIsLnbActive(false)}
            >
              <CatalogLink
                className={twMerge("btn", pageSlug1 === "company" && "active")}
                to="company/cover"
              >
                Company
              </CatalogLink>
            </div>
          </nav>

          <nav className="flex">
            <CatalogAutoplayButton
              className="etc-btn flex h-[80px] w-[80px] items-center justify-center"
              render={{
                play: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="24.5"
                    viewBox="0 0 21 24.5"
                  >
                    <path
                      id="다각형_11"
                      data-name="다각형 11"
                      d="M12.25,0,24.5,21H0Z"
                      transform="translate(21) rotate(90)"
                      fill="#fff"
                    />
                  </svg>
                ),
                pause: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21.738"
                    height="26.086"
                    viewBox="0 0 21.738 26.086"
                  >
                    <path
                      id="패스_6976"
                      data-name="패스 6976"
                      d="M96,90.086h7.248V64H96ZM110.49,64V90.086h7.248V64Z"
                      transform="translate(-96 -64)"
                      fill="#fff"
                      stroke="#000"
                      strokeWidth="0"
                    />
                  </svg>
                ),
              }}
            />
            <CatalogLink
              to="catalog-index"
              className="etc-btn flex h-[80px] w-[80px] items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22">
                <rect id="사각형_4033" data-name="사각형 4033" width="28" height="4" fill="#fff" />
                <rect
                  id="사각형_4034"
                  data-name="사각형 4034"
                  width="28"
                  height="4"
                  transform="translate(0 9)"
                  fill="#fff"
                />
                <rect
                  id="사각형_4035"
                  data-name="사각형 4035"
                  width="28"
                  height="4"
                  transform="translate(0 18)"
                  fill="#fff"
                />
              </svg>
            </CatalogLink>
          </nav>
        </div>
      </header>

      {/* lnb-container 추가 */}
      <div className={twMerge("lnb-container")}>
        <nav
          className={twMerge("lnb-bar technology", isLnbActive === "technology" && "active")}
          onMouseEnter={() => setIsLnbActive("technology")}
          onMouseLeave={() => setIsLnbActive(false)}
        >
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "lorawan" && "active")}
            to="technology/lorawan"
          >
            LoRaWAN IoT
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "dt-tech" && "active")}
            to="technology/dt-tech"
          >
            {lang === "en" ? "DT’s Core Technologies" : "DT 보유기술"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "why-dt" && "active")}
            to="technology/why-dt"
          >
            {lang === "en" ? "Key Features" : "기술 특장점"}
          </CatalogLink>
        </nav>

        <nav
          className={twMerge("lnb-bar solution", isLnbActive === "solution" && "active")}
          onMouseEnter={() => setIsLnbActive("solution")}
          onMouseLeave={() => setIsLnbActive(false)}
        >
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "total-solution" && "active")}
            to="/solution/total-solution/lot-end-to-end"
          >
            {lang === "en" ? "End-to-End LoRaWAN IoT Solution" : "LoRa 기반 IoT 통합 솔루션"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "safety-solution" && "active")}
            to="solution/safety-solution/cover"
          >
            {lang === "en" ? "Disaster Response and Safety Management" : "재난·안전 관리"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "city-solution" && "active")}
            to="solution/city-solution/cover"
          >
            {lang === "en" ? "Smart City" : "스마트 시티"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "agriculture-solution" && "active")}
            to="solution/agriculture-solution/cover"
          >
            {lang === "en" ? "Smart Agriculture" : "스마트 농업"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "mensuration-solution" && "active")}
            to="solution/mensuration-solution/cover"
          >
            {lang === "en" ? "Smart Metering" : "스마트 계량"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "industry-solution" && "active")}
            to="solution/industry-solution/cover"
          >
            {lang === "en" ? "Smart Industries" : "스마트 산업"}
          </CatalogLink>
        </nav>

        <nav
          className={twMerge("lnb-bar company", isLnbActive === "company" && "active")}
          onMouseEnter={() => setIsLnbActive("company")}
          onMouseLeave={() => setIsLnbActive(false)}
        >
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "about-dt" && "active")}
            to="company/about-dt"
          >
            About DT
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "certification" && "active")}
            to="company/certification"
          >
            {lang === "en" ? "Patents & Certifications" : "보유특허 및 인증"}
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "history" && "active")}
            to="company/history"
          >
            History
          </CatalogLink>
          <CatalogLink
            className={twMerge("lnb", pageSlug2 === "partner" && "active")}
            to="company/partner"
          >
            Partner
          </CatalogLink>
        </nav>
      </div>

      <nav className="nav-controll absolute bottom-0 left-0 flex w-full justify-between *:pointer-events-auto">
        <CatalogPagingButton
          direction="prev"
          className="flex h-[80px] w-[80px] items-center justify-center font-bold disabled:opacity-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28.32"
            height="25.076"
            viewBox="0 0 28.32 25.076"
          >
            <path
              id="패스_21"
              data-name="패스 21"
              d="M15.732,0V15.732H0"
              transform="translate(25.076 12.538) rotate(135)"
              fill="none"
              stroke={
                pageSlug1 === "intro" || pageSlug1 === "cover" || pageSlug1 === "last"
                  ? "#fff"
                  : "#808080"
              }
              strokeMiterlimit="10"
              strokeWidth="4"
            />
            <line
              id="선_1"
              data-name="선 1"
              x1="25.275"
              transform="translate(3.045 12.327)"
              fill="none"
              stroke={
                pageSlug1 === "intro" || pageSlug1 === "cover" || pageSlug1 === "last"
                  ? "#fff"
                  : "#808080"
              }
              strokeWidth="4"
            />
          </svg>
        </CatalogPagingButton>
        <CatalogPagingButton
          direction="next"
          className="flex h-[80px] w-[80px] items-center justify-center font-bold disabled:opacity-50 "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28.32"
            height="25.076"
            viewBox="0 0 28.32 25.076"
          >
            <path
              id="패스_21"
              data-name="패스 21"
              d="M15.731,15.732V0H0"
              transform="translate(14.368 1.414) rotate(45)"
              fill="none"
              stroke={
                pageSlug1 === "intro" || pageSlug1 === "cover" || pageSlug1 === "last"
                  ? "#fff"
                  : "#808080"
              }
              strokeMiterlimit="10"
              strokeWidth="4"
            />
            <line
              id="선_1"
              data-name="선 1"
              x2="25.275"
              transform="translate(0 12.326)"
              fill="none"
              stroke={
                pageSlug1 === "intro" || pageSlug1 === "cover" || pageSlug1 === "last"
                  ? "#fff"
                  : "#808080"
              }
              strokeWidth="4"
            />
          </svg>
        </CatalogPagingButton>
      </nav>
    </div>
  );
}
